import React from 'react';
import styles from 'assets/css/OverviewComponent.module.css';
import { IconTargetArrows } from '@ace/react-icons';
import { getUTCDateFromServerDate, omitYearIfCurrent, toDateSafe } from 'utils/dateUtils';

const SMARTGoalPartials = {
    SMARTGoalDisplay: (props) => (
        <span className={styles.moduleSMARTGoalDisplay}>
            <IconTargetArrows fill="#686f71" />
            <span className={styles.moduleSMARTGoalDates}>
                <span style={{fontWeight: 700}}>SMART Goal:</span> {omitYearIfCurrent(toDateSafe(props.SMARTGoalStartDate))} - {omitYearIfCurrent(toDateSafe(props.SMARTGoalEndDate))}
            </span>
            {props.SMARTGoalTimeLeft && props.SMARTGoalTimeLeft.length && <span className={styles.moduleSMARTGoalTimeLeft}>{props.SMARTGoalTimeLeft}</span>}
        </span>
    )
}


export default SMARTGoalPartials;
